/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type TopOfferCell_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopOffersContainer_lists$ref: FragmentReference;
declare export opaque type TopOffersContainer_lists$fragmentType: TopOffersContainer_lists$ref;
export type TopOffersContainer_lists = {|
  +topOffers: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentRefs: TopOfferCell_offer$ref,
      |}
    |}>
  |},
  +$refType: TopOffersContainer_lists$ref,
|};
export type TopOffersContainer_lists$data = TopOffersContainer_lists;
export type TopOffersContainer_lists$key = {
  +$data?: TopOffersContainer_lists$data,
  +$fragmentRefs: TopOffersContainer_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopOffersContainer_lists",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "OfferConnection",
      "kind": "LinkedField",
      "name": "topOffers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OfferEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TopOfferCell_offer"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "topOffers(first:50)"
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '7d24744e791f794327eb3db2725bc916';

module.exports = node;
